export default "__VITE_ASSET__BdRmPotk__"